import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import { installAntiInspect } from "@/lib/antiInspect";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import IntentionsBoard from "@/pages/IntentionsBoard";
import SpecialRequests from "@/pages/SpecialRequests";
import GroupPrayers from "@/pages/GroupPrayers";
import JoinWarriors from "@/pages/JoinWarriors";
import Liturgical from "@/pages/Liturgical";
import Testimonies from "@/pages/Testimonies";
import AdminDashboard from "@/pages/AdminDashboard";
import Psalms from "@/pages/Psalms";
import Profile from "@/pages/Profile";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function App() {
    installAntiInspect();
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Navbar />
                    <main>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/intentions" element={<ProtectedRoute><IntentionsBoard /></ProtectedRoute>} />
                            <Route path="/special" element={<SpecialRequests />} />
                            <Route path="/group-prayers" element={<GroupPrayers />} />
                            <Route path="/liturgical" element={<ProtectedRoute><Liturgical /></ProtectedRoute>} />
                            <Route path="/psalms" element={<ProtectedRoute><Psalms /></ProtectedRoute>} />
                            <Route path="/testimonies" element={<ProtectedRoute><Testimonies /></ProtectedRoute>} />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/join-warriors"
                                element={
                                    <ProtectedRoute>
                                        <JoinWarriors />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/profile"
                                element={
                                    <ProtectedRoute>
                                        <Profile />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute adminOnly>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </main>
                    <Footer />
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
